<template>
  <div class="category container">
    <div class="header">
      <van-search v-model="value" @click="$router.push('/search')" placeholder="请输入搜索关键词" />
      <div class="tab">
        <div class="item" :class="activeTab == index ? 'active':''" @click="onTabClick(index)" v-for="(item,index) in tab">{{item}}</div>
      </div>
    </div>

    <div style="border:1px solid rgba(199,199,199,1);"></div>
    <van-tree-select
      height="calc(100vh - 50px)"
      :items="items"
      :main-active-index.sync="active"
      @click-nav="onNavClick"
    >
      <template #content>
        <div class="main">
          <div class="main__item" v-for="(item,index) in cate" :key="index">
            <h3 class="main__item__title">{{item.name}}</h3>
            <div class="main__item__content">
              <van-grid :column-num="3" :border="false">
                <van-grid-item class="single" v-for="(single,idx) in item.children" :key="idx" @click="onNavigate(single)">
                  <image-pic fit="contain" :src="single.image" width="100%" height="52" v-if="activeTab!=0"/>
                  <span class="main__item__text">{{single.name}}</span>
                </van-grid-item>
              </van-grid>
            </div>
          </div>
        </div>
      </template>
    </van-tree-select>

    <tabbar></tabbar>
  </div>
</template>

<script>
import { getShopCategoryList, getItems, getContent } from '@/api/category'
import layer from "@/utils/layer";
export default {
  name: 'Category',
  data() {
    return {
      tab: ['电子元器件', '电子产品', '其他产品'],
      active: 0,
      activeIndex: 0,
      activeTab: 0,
      value: '',
      items: [],
      cate: []
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.query.type){
        vm.activeTab = from.query.type
        if (vm.activeTab){
          vm.getCateItems()
          vm.getCateContent()
        }
      }else{
        vm.getCateItems()
        vm.getCateContent()
      }
    })
  },
  created() {

  },
  mounted() {

  },
  methods: {
    getCateItems() {
      getItems({ type: this.activeTab }).then(res => {
        this.items = []
        if (res.success) {
          res.data.forEach((item,index) => {
            this.items.push({
              activeId: item.id,
              text: item.name
            })
            if(this.$route.query.id == item.id){
              this.active = index
            }
          })
        }
      })
    },
    getCateContent() {
      getContent({ pid: this.activeIndex, type: this.activeTab }).then(res => {
        if (res.success) {
          this.cate = res.data
        } else {
          this.cate = []
        }
      })
    },
    onNavigate(item) {
      this.$router.push({
        path: '/product',
        query: { id: item.id, pid: item.pid ,cname: item.name,type: item.type}
      })
    },
    onTabClick(index) {
      this.activeTab = index
      this.getCateItems()
      this.getCateContent()
    },
    onNavClick(index) {
      this.activeIndex = this.items[index].activeId // 这是我们通过index获取到当前点击的值
      this.getCateContent()
    },
    gotoSearchProduct() {
      if (this.value == '') {
        return
      }
      this.$router.push({
        path: '/searchProduct',
        query: {
          name: this.value
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .category {
    padding-top: 100px;
    .tab{
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      height:44px;
      .item{
        height:20px;
        font-size:14px;
        font-weight:400;
        line-height:20px;
        color:rgba(51,51,51,1);
        cursor: pointer;
      }
      .active{
        height:25px;
        font-size:18px;
        font-weight:bold;
        line-height:25px;
        color:rgba(254,0,59,1);
        border-bottom: 3px solid #FE003B;
      }
    }
    .main {
      box-sizing: border-box;
      padding: 10px;
      .main__item {
        .main__item__title {
          display: block;
          margin-block-start: 1em;
          margin-block-end: 1em;
          margin-inline-start: 0px;
          margin-inline-end: 0px;
          color: #333;
          font-size:14px;
          font-weight: bold;
        }
        .main__item__content {
          .single {
            text-align: center;
            color: #333;
            font-size:13px;
          }

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/category/index.vue